<div class="padding">
  <div>
    <div class="header">{{ 'assign_title' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="create()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <mat-form-field appearance="fill">
        <mat-label>{{ 'account_name' | translate }}</mat-label>
        <input type="text" name="account_name" matInput #account_name="ngModel" placeholder="Account Name" required
          [ngModel]="assign.account_name" disabled="true">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'client_id' | translate }}</mat-label>
        <input type="text" name="client_id" matInput #client_id="ngModel" placeholder="Client ID" required
          [(ngModel)]="assign.client_id" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="36" maxlength="36">
        <mat-hint>Minimum characters 36, {{assign.client_id == null ? 0 : assign.client_id?.length}}/36
          Characters</mat-hint>
        <mat-error *ngIf="client_id.hasError('required')">{{ 'clientId_required' | translate }}</mat-error>
        <mat-error *ngIf="client_id.hasError('minlength')">{{ 'clientId_minLength' | translate }}</mat-error>
        <mat-error *ngIf="client_id.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'client_secret' | translate }}</mat-label>
        <textarea name="client_secret" rows="3" matInput #client_secret="ngModel" placeholder="Client Secret" required
          [(ngModel)]="assign.client_secret" minlength="44" maxlength="44">
            <mat-hint>Minimum characters 44, {{assign.client_secret == null ? 0 : assign.client_secret?.length}}/44 Characters</mat-hint>
            <mat-error *ngIf="client_secret.hasError('required')">{{ 'clientSecret_required' | translate }}</mat-error>
            <mat-error *ngIf="client_id.hasError('minlength')">{{ 'clientSecret_minLength' | translate }}</mat-error>
        </textarea>
      </mat-form-field>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate
          }}</button>
      </div>

    </div>
  </form>

</div>